import "./whatsapp.css";
import Whatsapps from "../../assets/whatsapp.png";

function Whatsapp() {
  return (
    // <!-- start whatsapp_massenger  -->
    <div className="whatsapp">
      <a
        href="https://api.whatsapp.com/send?phone=201222214924"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={Whatsapps} alt="" />
      </a>
      <a
        href="https://api.whatsapp.com/send?phone=201222214924"
        target="_blank"
        rel="noopener noreferrer"
      >
        <p>
          <strong>تواصل معنا</strong>
        </p>
      </a>
    </div>
  );
}

export default Whatsapp;
